import React from 'react';
import {Routing} from "./components/routing";


export default function App() {
   return <Routing />
}
